import CreateClientForm from "@/components/Forms/CreateClientForm";

const DashboardAllClientsUpdate = () => {
  return <CreateClientForm />;
};

export default DashboardAllClientsUpdate;
